export default __webpack_public_path__ + "static/media/iconCompanyEmpty.589691a4.svg";